import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, UserPlus, ArrowLeft } from "lucide-react";
export const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    name: ""
  });
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle auth logic here
    navigate("/dashboard");
  };
  const toggleMode = () => {
    setIsLogin(!isLogin);
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-36">
      <button onClick={() => navigate("/")} className="absolute top-4 left-4 flex items-center gap-2 text-gray-600 hover:text-[#6366f1] transition-colors" data-id="element-37">
        <ArrowLeft size={20} data-id="element-38" />
        Back to Home
      </button>
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-39">
        <h2 className="text-center text-3xl font-bold text-gray-900" data-id="element-40">
          {isLogin ? "Welcome back" : "Create your account"}
        </h2>
        <p className="mt-2 text-center text-gray-600" data-id="element-41">
          {isLogin ? "Sign in to your account to continue" : "Start your free trial today"}
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-42">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-43">
          <form className="space-y-6" onSubmit={handleSubmit} data-id="element-44">
            {!isLogin && <div data-id="element-45">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-46">
                  Full name
                </label>
                <div className="mt-1" data-id="element-47">
                  <input id="name" name="name" type="text" required value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#6366f1] focus:border-[#6366f1]" data-id="element-48" />
                </div>
              </div>}
            <div data-id="element-49">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-50">
                Email address
              </label>
              <div className="mt-1" data-id="element-51">
                <input id="email" name="email" type="email" autoComplete="email" required value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#6366f1] focus:border-[#6366f1]" data-id="element-52" />
              </div>
            </div>
            <div data-id="element-53">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-54">
                Password
              </label>
              <div className="mt-1" data-id="element-55">
                <input id="password" name="password" type="password" autoComplete="current-password" required value={formData.password} onChange={e => setFormData({
                ...formData,
                password: e.target.value
              })} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#6366f1] focus:border-[#6366f1]" data-id="element-56" />
              </div>
            </div>
            <div data-id="element-57">
              <button type="submit" className="w-full flex justify-center items-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-gray-900 bg-[#d5ff00] hover:bg-[#c0e600] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#6366f1]" data-id="element-58">
                {isLogin ? <>
                    <LogIn className="w-4 h-4 mr-2" data-id="element-59" />
                    Sign in
                  </> : <>
                    <UserPlus className="w-4 h-4 mr-2" data-id="element-60" />
                    Create account
                  </>}
              </button>
            </div>
          </form>
          <div className="mt-6" data-id="element-61">
            <div className="relative" data-id="element-62">
              <div className="absolute inset-0 flex items-center" data-id="element-63">
                <div className="w-full border-t border-gray-300" data-id="element-64" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-65">
                <span className="px-2 bg-white text-gray-500" data-id="element-66">
                  {isLogin ? "New to Gigi?" : "Already have an account?"}
                </span>
              </div>
            </div>
            <div className="mt-6" data-id="element-67">
              <button onClick={toggleMode} type="button" className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#6366f1]" data-id="element-68">
                {isLogin ? "Create an account" : "Sign in"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};